export default "__VITE_ASSET__BB$f4bpG__"